module.exports = __webpack_public_path__ + "static/media/Untitled-1.f40a93b5.ai";


//////////////////
// WEBPACK FOOTER
// ./src/images/Untitled-1.ai
// module id = 151
// module chunks = 0